module.exports = __webpack_public_path__ + "img/morning-background.cb5183fb.png";